import { render, staticRenderFns } from "./EditarDetalle.vue?vue&type=template&id=bb85bfaa&"
import script from "./EditarDetalle.vue?vue&type=script&lang=js&"
export * from "./EditarDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports